import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAnalytics } from '@parcel2go/npm-p2g-app';

const useSignIn = () => {
  const { track } = useAnalytics();
  const { signinRedirect } = useAuth();

  const onSignInClick = useCallback(() => {
    track({ type: 'account_signin', payload: { location: 'checkout' } });
    signinRedirect({ state: window.location.href });
  }, [signinRedirect, track]);

  const onSignUpClick = useCallback(() => {
    track({ type: 'account_signup', payload: { location: 'checkout' } });
    signinRedirect({
      prompt: 'create',
      state: window.location.href
    });
  }, [signinRedirect, track]);

  return {
    onSignInClick,
    onSignUpClick
  };
};
export default useSignIn;
